<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-6">
						<h4 class="card-title"><i class="material-icons" (click)="back()">arrow_left</i>Purchase Order Inquiry</h4>
						<p class="card-category text-right">Search purchase orders by keywords and/or vendor</p>
					</div>
					<div class="card-body">

						<div *ngIf="searchError" class="alert alert-warning py-2 small mb-3" role="alert">{{ searchError }}</div>

						<form class="navbar-form">
							<div class="row g-2 align-items-start">
								<div class="col-md-2 col-sm-6">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Max rows</mat-label>
										<input matInput type="number" min="1" max="500" [formControl]="limitRef" (keydown.enter)="$event.preventDefault();searchOrders()">
										<mat-hint>1–500</mat-hint>
									</mat-form-field>
								</div>
								<div class="col-md-12 col-sm-12 mb-2">
									<mat-slide-toggle [formControl]="includeInactiveVendors">Include inactive vendors</mat-slide-toggle>
								</div>
								<div class="col-md-4 col-sm-12">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Vendor</mat-label>
										<mat-select [formControl]="vendorSelectRef" multiple>
											<mat-option *ngFor="let v of vendors" [value]="v.supplierid">{{ v.supplierid }} — {{ v.suppname }}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-5 col-sm-12">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Keywords</mat-label>
										<span matPrefix *ngIf="orderSearchRef.value">
											<button mat-icon-button class="p-0" type="button" (click)="clearForm()">
												<mat-icon class="p-0">clear</mat-icon>
											</button>
										</span>
										<input matInput [formControl]="orderSearchRef" placeholder="PO#, requisition, contact…" (keydown.enter)="$event.preventDefault();searchOrders()">
										<span matSuffix>
											<mat-progress-spinner *ngIf="loading" mode="indeterminate" diameter="16" color="accent" style="margin-right:4px"></mat-progress-spinner>
											<button mat-icon-button type="button" (click)="searchOrders()">
												<mat-icon class="p-0">search</mat-icon>
											</button>
										</span>
									</mat-form-field>
								</div>
							</div>
						</form>

						<p *ngIf="orderResults && orderResults.length" class="small text-muted mb-2">
							Showing {{ orderResults.length }} PO(s) — ordered by date desc.
						</p>

						<div *ngIf="showNoResults()" class="alert alert-info py-3 mb-3" role="status">
							<strong>No results.</strong> Nothing matched your search — try different keywords or vendors.
						</div>

						<!-- Results -->
						<div class="po-cards" *ngIf="orderResults && orderResults.length">
							<div class="po-card mb-4" *ngFor="let o of orderResults">

								<!-- Card Header -->
								<div class="po-card-header">
									<div class="po-card-header-main">
										<div class="po-id">
											<span class="po-label">PO#</span>
											<span class="po-number">{{ o.orderno }}</span>
										</div>
										<span class="status-badge" [ngStyle]="statusStyle(o)">
											{{ o.status_label || o.status || o.status_id }}
										</span>
									</div>

									<div class="po-card-meta">
										<div>
											<span>Vendor</span>
											<strong>
												<a class="link" href="javascript:void(0)" (click)="viewVendor(o.supplierno)">{{ o.supplierno }}</a>
												<span *ngIf="o.suppname"> — {{ o.suppname }}</span>
											</strong>
										</div>
										<div>
											<span>Contact</span>
											<strong>{{ o.contact || o.suppliercontact || '—' }}</strong>
										</div>
										<div>
											<span>Created</span>
											<strong>{{ o.orddate | date:'shortDate' }}</strong>
										</div>
										<div>
											<span>Delivery</span>
											<strong>{{ o.deliverydate | date:'shortDate' }}</strong>
										</div>
										<div>
											<span>Entered by</span>
											<strong>{{ o.initiator || '—' }}</strong>
										</div>
										<div>
											<span>Req#</span>
											<strong>{{ o.requisitionno || '—' }}</strong>
										</div>
										<div *ngIf="o.stat_comment">
											<span>Notes</span>
											<strong class="notes-text">{{ o.stat_comment }}</strong>
										</div>
									</div>
								</div>

								<!-- Line Items -->
								<div class="po-card-body">
									<table class="table table-sm po-line-table">
										<thead>
											<tr>
												<th>Item</th>
												<th>Description</th>
												<th class="text-end">Price</th>
												<th *ngIf="config.env?.package === 'tires'" class="text-end">FET</th>
												<th class="text-end">Ordered <span class="text-muted small">({{ getOrderedSum(o) }})</span></th>
												<th class="text-end">Received <span class="text-muted small">({{ getReceivedSum(o) }})</span></th>
												<th class="text-end">Outstanding</th>
												<th class="text-end">Net</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let det of o.details" class="poline">
												<td class="po-item-code">{{ det.itemcode }}</td>
												<td>{{ det.itemdescription }}</td>
												<td class="text-end text-nowrap">{{ det.unitprice | currency }}</td>
												<td *ngIf="config.env?.package === 'tires'" class="text-end text-nowrap">{{ det.fetcharge * det.quantityord | currency }}</td>
												<td class="text-end">{{ det.quantityord }}</td>
												<td class="text-end">{{ det.quantityrecd }}</td>
												<td class="text-end">{{ det.quantityord - det.quantityrecd }}</td>
												<td class="text-end text-nowrap">{{ lineNet(det) | currency }}</td>
											</tr>
										</tbody>
									</table>
								</div>

								<!-- Totals Footer -->
								<div class="po-card-footer">
									<div class="po-sum">
										<span>PO Total</span>
										<strong>{{ getPoTotal(o) | currency }}</strong>
									</div>
									<div class="po-sum">
										<span>Received</span>
										<strong>{{ getNetTotal(o) | currency }}</strong>
									</div>
								</div>

							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</div>
